import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ifElse } from 'aa_common/front-end/helpers'
import { ColumnType } from 'antd/es/table/interface'
import { yen } from 'common/helpers'
import { loadNs } from 'common/i18n-config'
import { PresenterDepreciationAdjustHistory } from 'common/open-api'

const t = loadNs(['components/organisms/internal-control/log-list-item-detail'])

export const renderDepreciation = (value: number | string, isHighlight?: boolean) => {
  return <div className={ifElse(isHighlight, 'depreciation-change', '')}>{ifElse(value, yen(value), value)}</div>
}

export const getColumns = (): ColumnType<any>[] => {
  return [
    {
      title: t('period'),
      key: 'period',
      sorter: false,
      width: 125,
      align: 'left',
      render: (_, record) => {
        return t('period_template', { year: record.year, month: record.month })
      },
    },
    {
      title: t('before_change_depreciation'),
      dataIndex: 'beforeChange',
      key: 'before_change_depreciation',
      sorter: false,
      width: 160,
      align: 'right',
      render: value => {
        return renderDepreciation(value)
      },
    },
    {
      title: '',
      key: 'arrow_column',
      sorter: false,
      width: 34,
      align: 'center',
      render: () => {
        return <FontAwesomeIcon icon={faArrowRight} style={{ color: '#747474', fontSize: '11px' }} />
      },
    },
    {
      title: t('after_change_depreciation'),
      dataIndex: 'afterChange',
      key: 'after_change_depreciation',
      sorter: false,
      width: 160,
      align: 'right',
      render: (value, record) => {
        return renderDepreciation(value, record?.beforeChange !== value)
      },
    },
    {
      title: '',
      key: 'empty_colum',
      sorter: false,
    },
  ]
}

export const prependMissingHistory = (
  missingHistory: PresenterDepreciationAdjustHistory[],
  fullHistory: PresenterDepreciationAdjustHistory[]
) => {
  const firstTermOfMissingHistory = missingHistory?.[0].term_month
  const firstTermOfFullHistory = fullHistory?.[0].term_month
  if (
    !firstTermOfMissingHistory?.year ||
    !firstTermOfMissingHistory?.month ||
    !firstTermOfFullHistory?.year ||
    !firstTermOfFullHistory?.month ||
    firstTermOfMissingHistory?.year < firstTermOfFullHistory?.year ||
    (firstTermOfMissingHistory?.year === firstTermOfFullHistory?.year &&
      firstTermOfMissingHistory?.month <= firstTermOfFullHistory?.month)
  ) {
    return missingHistory
  }

  const prependHistory: PresenterDepreciationAdjustHistory[] = []
  for (const item of fullHistory) {
    const currentTerm = item.term_month
    if (
      currentTerm?.year &&
      currentTerm?.month &&
      (currentTerm.year < firstTermOfMissingHistory.year ||
        (currentTerm.year === firstTermOfMissingHistory.year && currentTerm.month < firstTermOfMissingHistory.month))
    ) {
      prependHistory.push({
        term_month: { ...currentTerm },
        adjusted_accumulated_depreciation_amount: 0,
        depreciation_amount: 0,
        original_depreciation_amount: 0,
      })
    }
  }

  return [...prependHistory, ...missingHistory]
}
